module.exports = __webpack_public_path__ + "static/img/WechatIMG38.9ff73414.jpeg";